import './LineSeparator.css';

export function addListSeparatorLine(date: string) {
  return (
    <>
      <div className="list-separator">
        <div className="list-separator-line"></div>
        <div className="list-separator-date">{date}</div>
        <div className="list-separator-line"></div>
      </div>
    </>
  );
}
